import { themeType } from "shared/assets/theme";
import styled from "styled-components";

export const Page = styled.div`
  min-height: 100vh;
  background: ${(props) => props.theme.color.darkBg};
  color: #ffffff;
`;

export const Header = styled.header`
  position: sticky;
  top: 0;
  z-index: 10;
  background: ${(props) => props.theme.color.darkBg};
  border-bottom: 1px solid ${(props) => props.theme.color.grayBg};
`;

export const HeaderInner = styled.div`
  width: min(1120px, calc(100% - 3rem));
  min-height: 76px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;

  @media (max-width: 640px) {
    width: calc(100% - 2rem);
    min-height: 68px;
    gap: 0.75rem;
  }

  @media (max-width: 480px) {
    flex-wrap: wrap;
    padding: 0.75rem 0;
  }
`;

export const Brand = styled.a`
  color: #ffffff;
  font-size: 1.15rem;
  font-weight: 700;
  text-decoration: none;
  white-space: nowrap;
`;

export const Navigation = styled.nav`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: clamp(0.75rem, 2vw, 1.75rem);

  @media (max-width: 420px) {
    gap: 0.55rem;
  }
`;

export const NavigationLink = styled.a`
  color: ${(props) => props.theme.color.lightBg};
  font-size: 0.95rem;
  text-decoration: none;
  white-space: nowrap;

  &:hover,
  &:focus-visible {
    color: #ffffff;
    text-decoration: underline;
    text-underline-offset: 0.25rem;
  }

  @media (max-width: 420px) {
    font-size: 0.8rem;
  }
`;

export const LanguageSelect = styled.select`
  appearance: none;
  border: 1px solid ${(props) => props.theme.color.lightBg};
  border-radius: 999px;
  padding: 0.45rem 2rem 0.45rem 0.7rem;
  background-color: ${(props) => props.theme.color.darkBg};
  background-image: linear-gradient(45deg, transparent 50%, #9b9ea7 50%),
    linear-gradient(135deg, #9b9ea7 50%, transparent 50%);
  background-repeat: no-repeat;
  background-position: calc(100% - 10px) 50%, calc(100% - 6px) 50%;
  background-size: 4px 4px;
  color: #ffffff;
  font: inherit;
  font-size: 0.85rem;
  cursor: pointer;

  &:hover,
  &:focus-visible {
    background-color: ${(props) => props.theme.color.grayBg};
    outline: 2px solid #ffffff;
    outline-offset: 2px;
  }

  option {
    background: ${(props) => props.theme.color.darkBg};
    color: #ffffff;
  }

  @media (max-width: 420px) {
    padding: 0.4rem 1.75rem 0.4rem 0.55rem;
    font-size: 0.75rem;
  }
`;

export const Hero = styled.section`
  min-height: min(680px, calc(100vh - 76px));
  scroll-margin-top: 110px;
  display: flex;
  align-items: center;
  padding: 5rem 0;
  background: ${(props) => props.theme.color.darkBg};

  @media (max-width: 640px) {
    min-height: 68vh;
    padding: 4rem 0;
  }
`;

export const Section = styled.section<{ $color?: themeType }>`
  padding: clamp(4rem, 9vw, 7rem) 0;
  scroll-margin-top: 110px;
  background: ${(props) => props.theme.color[props.$color || "darkBg"]};
  color: ${(props) =>
    props.$color === "lightBg" ? props.theme.color.darkBg : "#ffffff"};
`;

export const Content = styled.div`
  width: min(1120px, calc(100% - 3rem));
  margin: 0 auto;

  @media (max-width: 640px) {
    width: calc(100% - 2rem);
  }
`;
